export const bookingCharges = {
  header: {
    title: "Opłaty",
    titleNew: "Nowe opłaty",
    sub: "Pozycje do umieszczenia na fakturze gościa.",
    subNew:
      "Na kolejną fakturę. Zafakturowany już nocleg jest widoczny powyżej, na swojej fakturze.",
  },
  loading: "Wczytywanie opłat…",
  empty: {
    title: "Brak zapisanych opłat",
    titleBilled: "Brak oczekujących opłat",
    sub: "Dodaj nocleg, sprzątanie, dodatki lub inne usługi.",
    subBilled: "Dodaj opłatę, aby utworzyć kolejną fakturę do tej rezerwacji.",
  },
  buttons: {
    addCharge: "Dodaj opłatę",
    addFirstCharge: "Dodaj pierwszą opłatę",
    manage: "Zarządzaj",
    manageTemplatesTitle: "Zarządzaj szablonami",
    add: "Dodaj",
    close: "Zamknij",
    cancel: "Anuluj",
    saving: "Zapisywanie…",
    saveCharge: "Zapisz opłatę",
    saveChanges: "Zapisz zmiany",
    deleting: "Usuwanie…",
    confirmDelete: "Tak, usuń",
    editTitle: "Edytuj",
    deleteTitle: "Usuń",
  },
  table: {
    item: "Pozycja",
    qty: "Ilość",
    unitPrice: "Cena jednostkowa",
    vat: "VAT",
    total: "Suma",
  },
  chips: {
    lodging: "Nocleg",
    discount: "Rabat",
    autoSynced: "Synchronizowane automatycznie",
  },
  // Resumen de la estancia bajo cada habitación.
  stay: {
    nights: "1 noc | {n} nocy",
    rooms: "1 pokój | {n} pokoi",
  },

  fields: {
    // De qué habitación es el cargo (reservas de varias habitaciones).
    room: "Pokój",
    roomAll: "Cała rezerwacja",
    roomHint: "Jeśli dotyczy jednego pokoju, trafi na jego fakturę.",
    date: "Data",
    category: "Kategoria",
    quantity: "Ilość",
    unitPriceFull: "Cena jednostkowa",
    vatPct: "VAT (%)",
    name: "Nazwa",
    price: "Cena",
    internalNotes: "Notatki wewnętrzne",
    paymentMethod: "Sposób płatności",
    paymentDate: "Data płatności",
    guestCount: "Liczba gości",
  },
  placeholders: {
    item: "Wybierz lub wpisz pozycję…",
    egCleaning: "np. Sprzątanie",
    internalNote: "Dodaj notatkę wewnętrzną…",
  },
  templates: {
    savedTitle: "Zapisane opłaty",
    noResults: 'Brak wyników dla "{query}"',
    emptyPre: "Brak zapisanych opłat. ",
    createOne: "Utwórz opłatę",
    manageTitle: "Własne opłaty",
    manageSub: "Twórz opłaty wielokrotnego użytku do swoich faktur.",
    emptyList: "Brak zapisanych opłat. Dodaj pierwszą powyżej.",
    noCategory: "Bez kategorii",
  },
  vat: {
    labelPct: "VAT {rate}%",
  },
  modal: {
    editTitle: "Edytuj opłatę",
    addSub: "Nowa pozycja na fakturze",
    editSub: "Edytuj szczegóły opłaty",
    totalCalculated: "Wyliczona suma",
  },
  common: {
    optional: "(opcjonalnie)",
    unspecified: "Nie podano",
  },
  invoice: {
    sectionLabel: "Faktura elektroniczna",
  },
  footer: {
    pending: "Do zafakturowania",
    totalDue: "Razem do zapłaty",
  },
  deleteModal: {
    title: "Usunąć opłatę?",
    sub: "Tej operacji nie da się cofnąć.",
  },
  autoCategory: {
    service: "Usługa",
    fee: "Opłata",
    extraGuest: "Dodatkowy gość",
    tax: "Podatek",
    cityTax: "Opłata miejscowa",
    adjustment: "Korekta",
    autoFallback: "Opłata automatyczna",
  },
  chargeBasis: {
    percentOfTotal: "Procent sumy",
    perNight: "Za noc",
    perPerson: "Za osobę",
    perPersonPerNight: "Za osobę za noc",
    perStay: "Za rezerwację",
  },
  toast: {
    descRequired: "Opis jest wymagany.",
    chargeAdded: "Opłata dodana.",
    chargeUpdated: "Opłata zaktualizowana.",
    chargeDeleted: "Opłata usunięta.",
    chargeSaved: "Opłata zapisana.",
    saveFailed: "Nie udało się zapisać.",
    deleteFailed: "Nie udało się usunąć.",
    warningTitle: "Uwaga",
    doneTitle: "Gotowe",
    errorTitle: "Błąd",
  },
  invoices: {
    title: "Wystawione faktury",
    noName: "Bez nazwy",
    conceptCount: "{count} pozycja | {count} pozycje | {count} pozycji",
    viewPdf: "Zobacz PDF",
    sendWhatsapp: "Wyślij przez WhatsApp",
    correct: "Skoryguj (faktura korygująca)",
    void: "Anuluj (faktura korygująca)",
    conceptsFoot:
      "Te pozycje są już zafakturowane. Pełny szczegół znajduje się w PDF.",
  },
  status: {
    draft: "Szkic",
    sent: "Wystawiona",
    processing: "Przetwarzanie",
    pending: "Oczekuje",
    error: "Błąd",
    corrected: "Skorygowana",
    voided: "Anulowana",
  },
  checkinModal: {
    title: "Dane rejestracji",
    bookingLink: "Rezerwacja #{code}",
    requestDate: "Data zgłoszenia: {date} o {time}",
  },
  payment: {
    desti: "Płatność na miejscu",
    efect: "Gotówka",
    movil: "Płatność mobilna",
    otro: "Inne sposoby płatności",
    platf: "Platforma płatnicza",
    tarjt: "Karta kredytowa",
    trans: "Przelew bankowy",
    treg: "Karta podarunkowa",
  },
};
